<script>
import RtButton from './rtButton';
export default {
  name: 'RtButtonGroup',
  components: {
    RtButton
  },
  props: {
    /**
     * @public 最大显示按钮数
     */
    maxBtns: {
      type: Number,
      default: 0
    },
    /**
     * @public 是否显示保存按钮
     */
    isSave: {
      type: Boolean,
      default: true
    },
    hasPrimary: {
      type: Boolean,
      default: true
    },
    /**
     * @public 是否显示后退按钮
     */
    isBack: {
      type: Boolean,
      default: true
    },
    hasBack: {
      type: Boolean,
      default: true
    },
    /**
     * @public 保存按钮文字
     */
    primaryName: {
      type: String,
      default () {
        return this.$tx('主要', 'xpc.common.main');
      }
    },
    /**
     * @public 按钮组类型
     */
    mode: {
      type: String,
      default: '',
      validator (value) {
        return ['button', 'icon', 'text', ''].includes(value);
      }
    },
    /**
     * @public 文本类型时的排列方式
     */
    direction: {
      type: String,
      default: 'horizontal',
      validator (value) {
        return ['horizontal', 'vertical'].includes(value);
      }
    }
  },
  data () {
    return {
      visibleBtnClass: 'rt-button-group-visible-btns'
    };
  },
  computed: {
    classes () {
      return [
        'rt-button-group',
        {
          [`rt-button-group-mode-${this.mode}`]: this.mode,
          [`rt-button-group-${this.direction}`]: this.mode === 'text'
        }
      ];
    },
    computedMaxBtns () {
      if (this.maxBtns) {
        return this.maxBtns;
      } else {
        return this.mode === 'button' ? 3 : 2;
      }
    }
  },
  methods: {
    /**
     * @deprecated
     * 方法已废弃
     */
    init () {},
    /**
     * @deprecated
     * 方法已废弃
     */
    removeBtns () {},
    /**
     * @deprecated
     * 方法已废弃
     */
    getNodeList (node) {},
    /**
     * @deprecated
     * 方法已废弃
     */
    moveBtns () {},
    save (event) {
      this.$emit('save', event);
    },
    back (event) {
      if (this.isBack && this.$router) {
        this.$router.back();
        return;
      }
      this.$emit('back', event);
    },
    /**
     * @private 根据不同模式限制传入的button内容
     */
    modifyButton (btn) {
      if (this.mode === 'icon') {
        if (btn.componentOptions.children) {
          btn.componentOptions.children[0].text = '';
        }
      }
      if (this.mode === 'text') {
        if (btn.componentOptions.propsData) {
          btn.componentOptions.propsData.iconName = '';
          btn.componentOptions.propsData.text = true;
          btn.componentOptions.propsData.type = 'plain';
          btn.componentOptions.propsData.background = false;
        }
      }

      return btn;
    }
  },
  render (h) {
    let btns;
    let showMore = false;
    let visibleBtns, popoverMoreBtns, popover;
    if (this.$slots.default) {
      btns = this.$slots.default.filter(item => item.tag);
      if (btns.length > this.computedMaxBtns) {
        showMore = true;
      }
    }

    if (showMore) {
      let count = 0;
      const res = btns.reduce(
        (obj, btn) => {
          if (btn.tag && count < this.computedMaxBtns) {
            count++;
            obj.visibleBtns.push(btn);
          } else {
            obj.popoverMoreBtns.push(btn);
          }
          obj.visibleBtns.map(this.modifyButton);
          obj.popoverMoreBtns.map(_btn => {
            if (_btn.componentOptions.propsData) {
              _btn.componentOptions.propsData.iconName = '';
            }
            return _btn;
          });
          return obj;
        },
        { visibleBtns: [], popoverMoreBtns: [] }
      );
      visibleBtns = res.visibleBtns;
      popoverMoreBtns = res.popoverMoreBtns;
      const moreBtn = h(
        'div',
        {
          class: 'rt-button-more',
          slot: 'reference'
        },
        [
          h('rt-button', {
            props: {
              'icon-name': 'rt-base-more',
              divider: this.mode === 'text',
              direction:
                this.direction === 'vertical' ? 'horizontal' : 'vertical'
            }
          })
        ]
      );

      const moreBtnsDiv = h(
        'div',
        {
          class: 'rt-button-group-popper-wrapper'
        },
        popoverMoreBtns
      );

      popover = h(
        'el-popover',
        {
          ref: 'popover',
          props: {
            trigger: 'hover',
            'popper-class': 'rtElPopover'
          }
        },
        [moreBtn, moreBtnsDiv]
      );
    } else {
      btns.map(this.modifyButton);
      visibleBtns = btns;
    }
    if (visibleBtns.length === 1) {
      this.visibleBtnClass = 'rt-button-group-visible-btns rt-button-group-visible-single'
    }
    return (
      <div class={this.classes}>
        {this.mode === 'button' && this.isSave && this.hasPrimary && (
          <div class="__primary">
            {this.$slots.primary ? (
              this.$slots.primary
            ) : (
              <rt-button
                icon-name="rt-base-circle-check-lined"
                color-type="primary"
                onClick={this.save}
              >
                {this.primaryName}
              </rt-button>
            )}
          </div>
        )}
        <div class={this.visibleBtnClass}>
          {visibleBtns}
          {showMore && (
            <div ref="more" class="button-group-more">
              {popover}
            </div>
          )}
        </div>

        {this.mode === 'button' && this.isBack && this.hasBack && (
          <div class="__back">
            <rt-button icon-name="rt-base-back" onClick={this.back}>
              返回
            </rt-button>
          </div>
        )}
      </div>
    );
  }
};
</script>



// WEBPACK FOOTER //
// rtButtonGroup.vue?0661410c